export class BackupZeroEtlResourceSelector {
    'condition';
    'include';
    'exclude';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "condition",
            "baseName": "condition",
            "type": "Condition",
            "format": ""
        },
        {
            "name": "include",
            "baseName": "include",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "exclude",
            "baseName": "exclude",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlResourceSelector.attributeTypeMap;
    }
    constructor() {
    }
}
